// @stayai checkbox custom script
(function() {

  const SELECTORS = {
    atcForm: `product-form form.shopify-product-form[action='/cart/add'][method='post']`,
    currentVariant: `input[name='id']`,
    stayai_subs_checkbox: `input#stayai_subs_checkbox`,
    allVariantOptions: `.product-info [data-block-type='variant-picker'] .variant-option input[type='radio']`,
    selectedVariantOption: (variantId) => `.product-info [data-block-type='variant-picker'] .selected.variant-option[data-variant-id] input[value='${variantId}']`,
    // Single-variant products with subscriptions store data on this element
    singleVariantWithSubs: `.product-info .has-only-default-variant[data-selling-plan-id]`,
    // Match both main product forms AND featured/bundle product forms
    atcBtn: `buy-buttons[form^='product-form-main-'] button[type='submit'], buy-buttons[form^='product-form-featured-product-'] button[type='submit']`,
    // Price display elements in the price-list
    salePrice: `.product-info price-list sale-price`,
    percentageBadge: `.product-info price-list .price-list__percentage-badge`
  };

  // Cache frequently accessed elements
  let cachedCheckbox = null;
  let cachedAtcBtn = null;

  // Helper to get cached checkbox or query it
  function getCheckbox() {
    return cachedCheckbox || (cachedCheckbox = document.querySelector(SELECTORS.stayai_subs_checkbox));
  }

  // Helper to get cached ATC button or query it
  function getAtcBtn(form) {
    let elem = form || document
    return elem.querySelector(SELECTORS.atcBtn);
  }

  // Function to get the currently selected variant option element
  function getSelectedVariantElement(form) {
    if (!form) return null;

    const currentVariant = form.querySelector(SELECTORS.currentVariant)?.value;
    if (!currentVariant) return null;

    return document.querySelector(SELECTORS.selectedVariantOption(currentVariant));
  }

  // Build the ATC label "Add to cart | <price> <compare-at>" from a variant data element.
  // Refills ON:  price = subscription price; struck-through = compare_at if set, else the one-time price.
  // Refills OFF: price = one-time price;     struck-through = compare_at only when the variant has one.
  // The struck-through "was" price sits to the RIGHT of the final price, styled smaller/lighter via CSS.
  // Returns null when no price data is available (caller leaves the button alone).
  function buildAtcLabel(dataEl, isChecked) {
    const sellingPlanPrice = dataEl.getAttribute('data-selling-plan-price');
    const variantPrice = dataEl.getAttribute('data-price');
    const comparePrice = dataEl.getAttribute('data-compare-price');
    const hasComparePrice = dataEl.getAttribute('data-has-compare-price') === 'true';

    if (!sellingPlanPrice && !variantPrice) return null;

    const useSub = isChecked && !!sellingPlanPrice;
    const price = useSub ? sellingPlanPrice : variantPrice;

    let compare = '';
    if (hasComparePrice && comparePrice) {
      compare = comparePrice;
    } else if (useSub && variantPrice && variantPrice !== sellingPlanPrice) {
      compare = variantPrice;
    }

    const priceClass = compare ? 'not-text-on-sale' : 'text-subdued';
    const compareHtml = compare
      ? ` <compare-at-price class="atc-was-price">${compare}</compare-at-price>`
      : '';

    return `Add to cart | <sale-price class="${priceClass}">${price || ''}</sale-price>${compareHtml}`;
  }

  // Function to update ATC button text based on checkbox state and variant prices
  function updateAtcBtnPrice(form) {
    const atcBtn = getAtcBtn(form);
    if (!atcBtn) return;

    const checkbox = getCheckbox();
    const isChecked = checkbox?.checked;

    // Check if there are any variant options on this page (multi-variant products)
    const allVariantOptions = document.querySelectorAll(SELECTORS.allVariantOptions);

    if (allVariantOptions.length) {
      // Multi-variant product: get prices from selected variant
      const selectedVariantElement = getSelectedVariantElement(form);
      if (!selectedVariantElement) {
        // Variant options exist but none selected - this shouldn't normally happen
        // Don't modify button text, let theme handle it
        return;
      }

      const label = buildAtcLabel(selectedVariantElement, isChecked);
      if (label) atcBtn.innerHTML = label;
      return;
    }

    // Check for single-variant products with subscriptions (like bundles)
    const singleVariantElement = document.querySelector(SELECTORS.singleVariantWithSubs);
    if (singleVariantElement) {
      const label = buildAtcLabel(singleVariantElement, isChecked);
      if (label) atcBtn.innerHTML = label;
      return;
    }

    // No variant options AND no single-variant with subscriptions
    // This is a simple single-variant product without subscriptions (like Eye Cream)
    // DON'T modify the button - let the theme's original text with price remain
  }

  // Show/hide an option's free-gift strip ([data-gift-gated]) based on whether the option's
  // effective price (subscription price when refills are ticked, one-time price otherwise)
  // reaches the threshold set on the strip (data-gift-threshold, in cents). Threshold 0 = always show.
  function updateGiftStrip(optionInput, parentElement, isChecked) {
    const giftStrips = parentElement.querySelectorAll('[data-gift-gated]');
    if (!giftStrips.length) return;

    const regularCents = parseInt(optionInput.getAttribute('data-price-cents'), 10);
    const subCents = parseInt(optionInput.getAttribute('data-selling-plan-price-cents'), 10);
    // Fall back to the one-time price if the variant has no selling plan
    const effectiveCents = isChecked && !Number.isNaN(subCents) ? subCents : regularCents;

    for (const strip of giftStrips) {
      const threshold = parseInt(strip.getAttribute('data-gift-threshold'), 10) || 0;
      // If we can't read a price, leave the strip alone rather than hiding a legitimate offer
      if (Number.isNaN(effectiveCents)) continue;
      const qualifies = threshold <= 0 || effectiveCents >= threshold;
      strip.style.display = qualifies ? '' : 'none';
    }
  }

  // Function to update price and savings elements on all variant options
  function updateVariantPriceElements(form) {
    const allVariantOptions = document.querySelectorAll(SELECTORS.allVariantOptions);
    if (!allVariantOptions.length) return;

    const checkbox = getCheckbox();
    const isChecked = checkbox?.checked;

    // Loop through all variant options and update their price/savings elements
    for (const optionInput of allVariantOptions) {
      const parentElement = optionInput.parentElement;
      if (!parentElement) continue;

      updateGiftStrip(optionInput, parentElement, isChecked);

      const priceEl = parentElement.querySelector('.variant-option__price');
      const savingEl = parentElement.querySelector('.variant-option__savings');
      const hasComparePrice = optionInput.getAttribute('data-has-compare-price') === 'true';

      if (isChecked) {
        // Subscription is checked - show subscription savings for ALL variants
        const subscriptionSavings = optionInput.getAttribute('data-selling-plan-saving-price');
        if (priceEl) priceEl.textContent = optionInput.getAttribute('data-selling-plan-eachitem-price') || '';
        if (savingEl) {
          savingEl.textContent = `Save ${subscriptionSavings || ''}`;
          // Always show savings when subscription is checked (subscription always has savings)
          savingEl.style.display = '';
        }
      } else {
        // Subscription is unchecked - only show savings if variant has compare_at_price
        const regularSavings = optionInput.getAttribute('data-saving-price');
        if (priceEl) priceEl.textContent = optionInput.getAttribute('data-eachitem-price') || '';
        if (savingEl) {
          if (hasComparePrice && regularSavings) {
            savingEl.textContent = `Save ${regularSavings}`;
            savingEl.style.display = '';
          } else {
            savingEl.textContent = '';
            savingEl.style.display = 'none';
          }
        }
      }
    }
  }

  // Function to update selling_plan input based on current variant
  function updateSellingPlanInput(form) {
    if (!form) return;

    const checkbox = getCheckbox();
    let sellingPlanInput = form.querySelector('input[name="selling_plan"]');

    // If checkbox doesn't exist or not checked, ensure selling_plan is empty
    if (!checkbox || !checkbox.checked) {
      if (sellingPlanInput) {
        sellingPlanInput.value = '';
      }
      return;
    }

    // Get or create selling_plan input
    if (!sellingPlanInput) {
      sellingPlanInput = createSellingPlanInput('', form);
    }

    // Try to get selling_plan_id from multi-variant selector first
    const selectedVariantElement = getSelectedVariantElement(form);
    if (selectedVariantElement) {
      sellingPlanInput.value = selectedVariantElement.getAttribute('data-selling-plan-id') || '';
      return;
    }

    // Try to get selling_plan_id from single-variant element (bundles)
    const singleVariantElement = document.querySelector(SELECTORS.singleVariantWithSubs);
    if (singleVariantElement) {
      sellingPlanInput.value = singleVariantElement.getAttribute('data-selling-plan-id') || '';
      return;
    }

    // No variant data found, clear the selling plan
    sellingPlanInput.value = '';
  }

  // Function to update the main price display (sale-price and percentage badge)
  // Note: Percentage badge only updates on bundle products (single-variant with subscriptions)
  function updatePriceDisplay(form) {
    // Check if this is a single-variant product with subscriptions (bundle)
    const singleVariantElement = document.querySelector(SELECTORS.singleVariantWithSubs);
    
    // Only proceed if this is a bundle product
    if (!singleVariantElement) return;

    const salePrice = document.querySelector(SELECTORS.salePrice);
    const percentageBadge = document.querySelector(SELECTORS.percentageBadge);
    
    // If no price display elements found, nothing to update
    if (!salePrice && !percentageBadge) return;

    const checkbox = getCheckbox();
    const isChecked = checkbox?.checked;

    // Get the prices and percentages based on checkbox state
    if (isChecked) {
      const subscriptionPrice = singleVariantElement.getAttribute('data-selling-plan-price');
      const subscriptionPercent = singleVariantElement.getAttribute('data-selling-plan-percent-savings');
      
      if (salePrice && subscriptionPrice) {
        // Find the text node or update the content (preserve the sr-only span)
        const srOnlySpan = salePrice.querySelector('.sr-only');
        if (srOnlySpan) {
          salePrice.innerHTML = '';
          salePrice.appendChild(srOnlySpan);
          salePrice.appendChild(document.createTextNode(subscriptionPrice));
        } else {
          salePrice.textContent = subscriptionPrice;
        }
      }
      
      if (percentageBadge && subscriptionPercent) {
        // Update percentage badge - preserve the sr-only span
        const srOnlySpan = percentageBadge.querySelector('.sr-only');
        if (srOnlySpan) {
          percentageBadge.innerHTML = '';
          percentageBadge.appendChild(srOnlySpan);
          percentageBadge.appendChild(document.createTextNode(`Save ${subscriptionPercent}%`));
        } else {
          percentageBadge.textContent = `Save ${subscriptionPercent}%`;
        }
        percentageBadge.style.display = '';
      }
    } else {
      const regularPrice = singleVariantElement.getAttribute('data-price');
      const regularPercent = singleVariantElement.getAttribute('data-percent-savings');
      const hasComparePrice = singleVariantElement.getAttribute('data-has-compare-price') === 'true';
      
      if (salePrice && regularPrice) {
        // Find the text node or update the content (preserve the sr-only span)
        const srOnlySpan = salePrice.querySelector('.sr-only');
        if (srOnlySpan) {
          salePrice.innerHTML = '';
          salePrice.appendChild(srOnlySpan);
          salePrice.appendChild(document.createTextNode(regularPrice));
        } else {
          salePrice.textContent = regularPrice;
        }
      }
      
      if (percentageBadge) {
        if (hasComparePrice && regularPercent && parseInt(regularPercent) > 0) {
          // Update percentage badge - preserve the sr-only span
          const srOnlySpan = percentageBadge.querySelector('.sr-only');
          if (srOnlySpan) {
            percentageBadge.innerHTML = '';
            percentageBadge.appendChild(srOnlySpan);
            percentageBadge.appendChild(document.createTextNode(`Save ${regularPercent}%`));
          } else {
            percentageBadge.textContent = `Save ${regularPercent}%`;
          }
          percentageBadge.style.display = '';
        } else {
          // Hide badge when no compare_at_price or 0% savings
          percentageBadge.style.display = 'none';
        }
      }
    }
  }

  // Batch update function to update all related elements
  function updateAll(form) {
    updateSellingPlanInput(form);
    updateAtcBtnPrice(form);
    updateVariantPriceElements(form);
    updatePriceDisplay(form);
  }

  // Wait for all matching forms to be ready, then optionally wait for checkbox
  elementsReady(SELECTORS.atcForm).then((forms) => {
    if (!forms.length) return;

    const checkboxPromise = document.querySelector(SELECTORS.stayai_subs_checkbox)
    ? Promise.resolve(document.querySelector(SELECTORS.stayai_subs_checkbox))
    : elementReady(SELECTORS.stayai_subs_checkbox).catch(() => null);

    checkboxPromise.then((checkbox) => {
      cachedCheckbox = checkbox || null;

      document.addEventListener('submit', (event) => {
        const targetForm = event.target.tagName === 'FORM' ? event.target : event.target.closest('form');
        if (forms.includes(targetForm)) {
          updateSellingPlanInput(targetForm);
        }
      }, true);

      forms.forEach((form) => {
        initializeFormWithCheckbox(form, checkbox);
      });
    });

    // Function to complete initialization for a single form
    function initializeFormWithCheckbox(form, checkbox) {
      // Cache the checkbox the first time we find one
      if (checkbox && !cachedCheckbox) {
        cachedCheckbox = checkbox;
      }

      // Ensure selling_plan input exists (only if checkbox exists)
      if (checkbox && !form.querySelector('input[name="selling_plan"]')) {
        createSellingPlanInput(null, form);
      }

      // Update all on initial load (after a delay to ensure theme JS has finished)
      setTimeout(() => updateAll(form), 100);

      // Also update on window load as a fallback for late theme scripts
      window.addEventListener('load', () => {
        setTimeout(() => updateAll(form), 100);
      });

      // Listen for variant changes (event bubbles from document)
      document.addEventListener('variant:change', () => {
        console.log('variant change for ', form)
        updateAll(form)
      });

      // Listen for checkbox changes (only if checkbox exists)
      if (checkbox) {
        checkbox.addEventListener('change', () => {
          updateAll(form);

          // Dispatch variant:change event to notify other listeners
          const currentVariantId = form.querySelector(SELECTORS.currentVariant)?.value;
          if (currentVariantId) {
            form.dispatchEvent(new CustomEvent('variant:change', {
              bubbles: true,
              detail: {
                formId: form.id,
                variant: { id: currentVariantId },
              },
            }));
          }
        }); 
      }
    }

    forms.forEach((form) => {
      initializeFormWithCheckbox(form, checkbox);
    });
  }).catch(e => console.error('Error initializing stayai-pdp:', e))


  // Helper function to wait for ALL elements matching a selector to be ready
  // Resolves once at least one is present, returning the full NodeList as an Array
  function elementsReady(selector) {
    return new Promise((resolve) => {
      const els = document.querySelectorAll(selector);
      if (els.length > 0) {
        resolve(Array.from(els));
        return;
      }

      const observer = new MutationObserver(() => {
        const foundElements = document.querySelectorAll(selector);
        if (foundElements.length > 0) {
          observer.disconnect();
          resolve(Array.from(foundElements));
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    });
  }

  // Helper function to wait for element to be ready (resolves with first match)
  function elementReady(selector) {
    return new Promise((resolve) => {
      const el = document.querySelector(selector);
      if (el) {
        resolve(el);
        return;
      }

      const observer = new MutationObserver(() => {
        const foundElements = document.querySelectorAll(selector);
        if (foundElements.length > 0) {
          observer.disconnect();
          resolve(foundElements[0]);
        }
      });

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    });
  }

  // Subscription info tooltip behavior (hover on desktop, tap on mobile)
  elementReady('[data-subs-info-trigger]').then((trigger) => {
    const tooltip = document.querySelector('[data-subs-info-tooltip]');
    const closeBtn = document.querySelector('[data-subs-info-close]');
    if (!trigger || !tooltip) return;

    let hideTimeout = null;
    const isTouchDevice = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    function show() {
      clearTimeout(hideTimeout);
      tooltip.classList.add('is-visible');
    }

    function hide() {
      tooltip.classList.remove('is-visible');
    }

    function hideWithDelay() {
      hideTimeout = setTimeout(hide, 200);
    }

    trigger.addEventListener('mouseenter', () => {
      if (!isTouchDevice()) show();
    });
    trigger.addEventListener('mouseleave', () => {
      if (!isTouchDevice()) hideWithDelay();
    });
    tooltip.addEventListener('mouseenter', () => {
      if (!isTouchDevice()) { clearTimeout(hideTimeout); }
    });
    tooltip.addEventListener('mouseleave', () => {
      if (!isTouchDevice()) hideWithDelay();
    });

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      tooltip.classList.toggle('is-visible');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        hide();
      });
    }

    document.addEventListener('click', (e) => {
      if (!trigger.contains(e.target) && !tooltip.contains(e.target)) {
        hide();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') hide();
    });
  });

  // Helper function to create selling_plan input
  function createSellingPlanInput(sellingPlanId, form) {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'selling_plan';
    input.classList.add('stayai-selling-plan--js-added');
    if (sellingPlanId) {
      input.value = sellingPlanId;
    }
    form.appendChild(input);
    return input;
  }


})();